module.exports = __webpack_public_path__ + "img/ewm12.7baba4dd.jpg";